export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "v3.418/checksum.worker.bundle.worker.js");
}
